import React from "react";
import {Link} from "react-router-dom";
import Equipo from "../../assets/img/about.png"
const About = () => {
  return (
    <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
      <div className="container">
        <div className="row g-5">
          {/* Sección de texto */}
          <div className="col-lg-7">
            <div className="section-title mb-4">
              <h5 className="position-relative d-inline-block text-primary text-uppercase">
                Sobre Lash
              </h5>
              <h1 className="display-5 mb-0">Compromiso con tu salud bucal</h1>
            </div>
            <h4 className="text-body fst-italic mb-4">
              25 años de experiencia en la odontología integral
            </h4>
            <p className="mb-4">
              Nosotras #SomosLash, un equipo multidisciplinario de odontología
              integral y queremos proponerte que alcances tu mejor sonrisa, para
              que puedas disfrutarla y vivirla día a día. Cada una de nosotras
              podrá ayudarte a recuperar la salud de tu boca y el sentido
              estético.
            </p>
            <div className="row g-3">
              <div className="col-sm-6 wow zoomIn" data-wow-delay="0.3s">
                <h5 className="mb-3">
                  <i className="fa fa-check-circle text-primary me-3"></i>Salud
                </h5>
                <h5 className="mb-3">
                  <i className="fa fa-check-circle text-primary me-3"></i>
                  Estética Bucal
                </h5>
              </div>
              <div className="col-sm-6 wow zoomIn" data-wow-delay="0.6s">
                <h5 className="mb-3">
                  <i className="fa fa-check-circle text-primary me-3"></i>Años
                  de experiencia
                </h5>
                <h5 className="mb-3">
                  <i className="fa fa-check-circle text-primary me-3"></i>
                  Equipamiento de vanguardia
                </h5>
              </div>
            </div>
            <Link to="/appointment" className="btn btn-primary py-3 px-5 mt-4 wow zoomIn" data-wow-delay="0.6s">
              Gestioná tu turno
            </Link>
          </div>
          {/* Sección de imagen */}
          <div className="col-lg-5" style={{ minHeight: "500px" }}>
            <div className="position-relative h-100">
              <img
                className="position-absolute w-100 h-100 rounded wow zoomIn"
                data-wow-delay="0.9s"
                src={Equipo}
                alt="Sobre Lash"
                style={{ objectFit: "cover" }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
